import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx } from "react/jsx-runtime";
// src/components/ThumbDown.tsx
const ThumbDownIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13 19.005a1 1 0 0 1-1-1v-1a5 5 0 0 0-4-4.9v-5.1a2 2 0 0 1 2-2h7A1 1 0 0 0 17.085 5c.087-.007.238.017.43.21.2.2.396.54.508 1.007l.974 4.869a1 1 0 0 1-.997.918h-3a1 1 0 0 0-1 1v5a1 1 0 0 1-1 1Zm-5.4-15.2a2 2 0 0 0-1.6-.8H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h3a3 3 0 0 1 3 3v1a3 3 0 0 0 6 0v-4h2a3 3 0 0 0 3-3 1 1 0 0 0-.02-.196l-1-5a1.162 1.162 0 0 0-.006-.032c-.177-.753-.524-1.46-1.044-1.98-.518-.518-1.207-.841-1.967-.792H10a4 4 0 0 0-2.4.8Zm-1.6 8.2H4v-7h2v7Z",
		fill: props.fill || "currentColor"
	})
}));
export { ThumbDownIcon };
